import { Link } from "react-router-dom";
import { CONTACT_EMAIL } from "@/constants/links";
import { INDUSTRY_ORDER, INDUSTRY_LABELS } from "@/data/industries";

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="container">
      <div className="ft">
        <Link to="/" className="logo" data-testid="footer-logo">
          <span className="wm" style={{ fontSize: 20 }}>
            Clear<span style={{ color: "#2FD3C6" }}>view</span>
            <span style={{ color: "#EC4899" }}>.</span>
          </span>
        </Link>
        <div className="links">
          <Link to="/how-it-works" data-testid="footer-how">How it works</Link>
          <Link to="/reports" data-testid="footer-reports">Reports</Link>
          <Link to="/security" data-testid="footer-security">Security</Link>
          <Link to="/about" data-testid="footer-about">About</Link>
          <Link to="/apply" data-testid="footer-apply">Apply for a demo</Link>
          <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-contact">Contact</a>
        </div>
      </div>

      <div className="ft-industries" data-testid="footer-industries">
        <div className="ft-industries-label">Industries we build for</div>
        <div className="ft-industries-links">
          {INDUSTRY_ORDER.map((slug) => (
            <Link
              key={slug}
              to={`/for/${slug}`}
              data-testid={`footer-industry-${slug}`}
            >
              {INDUSTRY_LABELS[slug]}
            </Link>
          ))}
        </div>
      </div>

      <div className="ft-seal">© Clearview · A Kindra company · Brisbane · Read-only by architecture</div>
    </div>
  </footer>
);
